export const XsiLogo = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="49" viewBox="0 0 54 49" fill="none">
        <g clipPath="url(#clip0_6333_87852)">
            <path d="M27.1821 18.6981L21.0287 24.3979L27.1821 30.0978L33.3355 24.3979L27.1821 18.6981Z" fill="#3B2E85"/>
            <path d="M7.09663 18.7762L0.943237 24.4761L7.09663 30.1759L13.25 24.4761L7.09663 18.7762Z" fill="#3B70E8"/>
            <path d="M47.4272 18.7352L41.2738 24.4351L47.4272 30.1349L53.5806 24.4351L47.4272 18.7352Z" fill="#60E4FF"/>
            <path d="M17.1228 9.37877L10.9694 15.0786L17.1228 20.7785L23.2762 15.0786L17.1228 9.37877Z" fill="#3B70E8"/>
            <path d="M17.1492 28.0858L10.9958 33.7856L17.1492 39.4855L23.3026 33.7856L17.1492 28.0858Z" fill="#3B70E8"/>
            <path d="M40.942 5.9608L47.0954 11.6606L53.2488 5.9608L47.0954 0.260959L40.942 5.9608Z" fill="#60E4FF"/>
            <path d="M30.9091 15.1654L37.0625 20.8652L43.2159 15.1654L37.0625 9.46555L30.9091 15.1654Z" fill="#60E4FF"/>
            <path d="M31.1726 33.7855L37.326 39.4854L43.4794 33.7855L37.326 28.0857L31.1726 33.7855Z" fill="#60E4FF"/>
            <path d="M41.1222 43.0018L47.2755 48.7017L53.4289 43.0018L47.2755 37.302L41.1222 43.0018Z" fill="#60E4FF"/>
            <path d="M1.06136 5.90269L7.21475 11.6025L13.3681 5.90269L7.21475 0.20285L1.06136 5.90269Z" fill="#60E4FF"/>
            <path d="M0.944539 43.0028L7.09793 48.7026L13.2513 43.0028L7.09793 37.3029L0.944539 43.0028Z" fill="#60E4FF"/>
        </g>
        <defs>
            <clipPath id="clip0_6333_87852">
            <rect width="52.9436" height="48.7837" fill="white" transform="translate(0.790314 0.0605469)"/>
            </clipPath>
        </defs>
    </svg>
)